import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import { useTheme } from '@mui/material/styles'
import { Text } from '@mxenabled/mxui'

import { formatCurrency } from '../../../../core/utils/NumberFormatting'

interface ProgressBarProps {
  label: string
  amount: number
  percentage: number
  isBold?: boolean
}

const ProgressBar = ({ label, amount, percentage, isBold }: ProgressBarProps) => {
  const theme = useTheme()
  return (
    <Stack sx={{ gap: 4 }}>
      <Stack sx={{ alignItems: 'center', flexDirection: 'row', justifyContent: 'space-between' }}>
        <Text variant="caption">{label}</Text>
        <Text bold={isBold} variant="caption">
          {formatCurrency(amount, '0,0.00')}
        </Text>
      </Stack>
      <Stack sx={{ bgcolor: theme.palette.warning.lighter, height: 12, borderRadius: 6 }}>
        <Box
          sx={{
            bgcolor: theme.palette.warning.main,
            height: 12,
            borderRadius: 6,
            width: `${percentage}%`,
          }}
        />
      </Stack>
    </Stack>
  )
}

export default ProgressBar
